var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLocationIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-9378.422 -2754.422)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,12.448c0-1.155,1.87-2.012,4.64-2.373l-.9-.895a5.358,5.358,0,1,1,7.5.006l-.89.889C13.131,10.437,15,11.293,15,12.448,15,13.971,11.651,15,7.5,15S0,13.971,0,12.448Zm.714,0c0,.9,3.047,1.838,6.786,1.838s6.785-.936,6.785-1.838c0-.673-1.86-1.452-4.571-1.729L7.753,12.682a.359.359,0,0,1-.506,0L5.284,10.719C2.577,11,.714,11.773.714,12.448Zm2.143-7.09A4.626,4.626,0,0,0,4.248,8.672L7.5,11.924l3.246-3.247a4.643,4.643,0,1,0-7.89-3.319ZM5,5.358a2.5,2.5,0,1,1,2.5,2.5A2.5,2.5,0,0,1,5,5.358Zm.714,0A1.786,1.786,0,1,0,7.5,3.572,1.785,1.785,0,0,0,5.714,5.358Z",
    transform: "translate(9378.422 2754.422)",
    fill: "#0c4767"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(9383.422 2757.322)",
    fill: "none",
    stroke: "#fd9926",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.5,
    cy: 2.5,
    r: 2,
    fill: "none"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIcon);
export default __webpack_public_path__ + "static/media/location_icon.6d371e0f91d927c69819a19829973c25.svg";
export { ForwardRef as ReactComponent };